import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  color: ${(props) => props.color ?? "#fff"};
  font-size: ${(props) => props.fontSize ?? "1.125rem"};
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
  font-weight: ${(props) => props.fontWeight ?? "700"};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 15px 1.375rem 0px;
  overflow-y: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const ImageDiv = styled.div`
  width: 35px;
  height: 35px;
  background: #15aee5;
  margin-right: 10px;
  border-radius: 50%;
`;

export const CompanyContainer = styled.div`
  width: 100%;
  padding: 10px;
  border: solid 2px #008395;
  border-radius: 10px;
  margin-bottom: 1.5rem;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  font-weight: normal;
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  border-bottom: ${(props) => props.borderBottom ?? "10px"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#474747"};
  font-size: 14px;
  font-weight: ${(props) => props.fontWeight ?? "700"};
  padding-left: ${(props) => props.paddingLeft ?? "0px"};
  padding-right: 10px;
`;

export const RowHeader = styled.div`
  background-color: #008395;
  justify-content: space-between;
  padding: 0px 0px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const GridItem = styled.div`
  line-height: 2rem;
  font-size: ${(props) => props.fontSize ?? "16px"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#fff"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: 5px 10px;
  align-content: ${(props) => props.alignContent ?? "normal"};
  border-top-left-radius: ${(props) => props.leftRadius ?? "0px"};
  border-top-right-radius: ${(props) => props.rightRadius ?? "0px"};
`;

export const GridItemImage = styled.div`
  line-height: 2rem;
  color: #fff;
  align-self: center;
  padding: 5px 10px;
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
`;
